<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_6"></a>For Anna Franceschelli,<br/>A source of joy and jubilation <span class="small">K. P</span>.</p>
<p class="dedication">For Isabel and Hazel,<br/>with all my love <span class="small">P. D</span>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05dedication.vue?e60ea334